import { ReactNode } from "react";
import { Box } from "shared/components/Spor";

export const ShowIfTrue = ({
  show,
  children,
}: {
  show: boolean;
  children: ReactNode;
}) => {
  if (!show) {
    return null;
  }

  return (
    <Box
      css={{
        "@keyframes fadeIn": {
          "0%": { opacity: 0 },
          "100%": { opacity: 1 },
        },
        animation: "fadeIn 250ms cubic-bezier(0.4, 0, 0.2, 1)",
      }}
    >
      {children}
    </Box>
  );
};
